export default {
    // 通用
    all: 'All',
    search: 'Search',
    run: 'Run',
    stby: 'Stby',
    alarm: 'Alarm',
    stop: 'stop',
    off: 'off',
    addTime: 'Add Time',
    updateTime: 'Update Time',
    runStatus: 'Run Status',
    runError: 'Error',
    temperature: 'Temperature',
    pressure: 'Pressure',
    flow: 'Flow',
    airVolume: 'Air Volume',
    weight: 'Weight',
    conditions: 'Query Conditions',
    startTime: 'Start Time',
    endTime: 'End Time',
    exportData: 'Export Data',
    add: 'Add',
    delete: 'Delete',
    ok: 'OK',
    cancel: 'Cancel',
    select: 'Select',
    action: 'Actions',
    edit: 'Edit',
    info: 'Info',
    addSuccess: 'Add Success',
    updateSuccess: 'Update Success',
    deleteSuccess: 'Delete Success',
    delSelectEmpty: 'Please select items that need to be deleted.',
    hotRunnerID: 'Hot Runner ID',
    moldNo: 'Mold No',
    moldTempMachine: 'Mold Temp.',
    threeMachine: 'Three Machine',
    coolWaterMachine: 'Cooling Water',
    cadDryer: 'CAD Dryer',
    conveyorBelt: 'Conveyor Belt',
    feedSystem: 'Feed System',
    robotMachine: 'Robot',
    injectionMachine: 'Injection',
    tmc: 'TMC',
    hediDryer: 'HED-I Dryer',
    refresh: 'Refresh',
    deleteConfirm: 'Do you want to delete',
    // 登录页面
    account: 'Account',
    password: 'Password',
    login: 'Login',
    companyName: 'WEIHAI YUDO ENG CO., LTD',
    icp: '鲁ICP备18056748号',
    loginEmpty: 'The account name or password cannot be empty.',
    loginEmpty1: 'The phone number cannot be empty.',
    loginEmpty2: 'Phone number format is not correct',
    loginEmpty3: 'The phone number or verification code cannot be empty.',
    loginEmpty4: 'Please swipe to complete verification',
    loginEmpty5: 'Phone number, verification code or password cannot be empty',
    loginMethod0: 'AccountLogin',
    loginMethod1: 'MobilePhoneLogin',
    register: 'register',
    phoneNumber: 'phone number',
    verificationCode: 'verification code',
    getVCode: 'get code',
    send: ' send',
    titleName0: 'Login to TMCC system',
    titleName1: 'Register for TMCC system',
    // header
    rank0: 'VIP',
    rank1: 'Admin',
    rank2: 'Normal',
    // main navbar
    menu0: 'Equipments',
    menu1: 'shopLayout',
    menu2: 'Productions',
    menu3: 'Analysis',
    menu4: 'Alarms',
    menu5: 'Users',
    menu6: 'System',
    // 我的设备
    equipmentSubTitle: 'About Equipment Management',
    addGroup: 'Add Group',
    groupName: 'Group Name',
    tagName: 'Workshop Name',
    groupNameEmpty: 'The name of the group can not be empty.',
    shopEmpty: 'Please selec workshop now.',
    addGroupSuccess: 'Group successfully added',
    finishNum: 'Output',
    finishRate: 'Finish',
    useRate: 'OEE',
    powerNum: 'Power',
    oeeReport: 'OEE Report',
    groupInfo: 'Group Info',
    // 机组详情
    back: 'Back',
    addDevice: 'Add Device',
    delDevice: 'Delete Device',
    deviceName: 'Device Name',
    deviceSerial: 'Device Serial',
    deviceType: 'Device Type',
    deviceModel: 'Device Model',
    deviceRegisteTime: 'Registration Time',
    deviceEmpty: 'Please select at least one device.',
    baseInfo: 'Base Info',
    realTimeData: 'Real-Time Data',
    watchData: 'Data Monitoring',
    realTimeChart: 'Chart',
    powerkwh: 'Power',
    noChart: 'No Chart',
    // 模温机
    mtsv: 'Set Temp.',
    mtow: 'Water Temp.',
    mtbw: 'Backwater Temp.',
    mttup: 'Alarm High',
    mttlow: 'Alarm Low',
    mtrp: 'Actual Press.',
    mtflow: 'Water Flow',
    // 三机一体
    tmsv: 'Set Reg.',
    tmpv: 'Actual Reg.',
    tmdsv: 'Set Dryer',
    tmdpv: 'Actual Dryer',
    tmtup: 'Alarm High',
    tmtlow: 'Alarm Low',
    tmback: 'Backair Temp.',
    tmcwp: 'Coolwater P.',
    tmcwf: 'Coolwater F.',
    tmcwt: 'Coolwater T.',
    tmdp: 'Dew Point',
    tmoav: 'Outair Volume',
    // 冷水机
    cwsv: 'Set Temp.',
    cwow: 'Water Temp.',
    cwam: 'Alarm Temp.',
    // 压缩空气干燥机
    cadsv: 'Set Temp.',
    cadpv: 'Actual Temp.',
    cadtup: 'High T. Limit',
    cadtlow: 'Low T. Limit',
    cadpup: 'High P. Limit',
    cadplow: 'Low P. Limit',
    cadback: 'Backair Temp.',
    caddp: 'Dew Point',
    cadcap: 'CA Press.',
    cadcadp: 'CA Dew Point',
    // 传送带
    // 供料系统
    fscw: 'Cur. Weight',
    fshw: 'Cum. Weight',
    // 机械手
    rtt: 'Take Time',
    rct: 'Periodic Time',
    rtn: 'Take Count',
    rrpm: 'RPM',
    rworkmode: 'Work Mode',
    unknow: 'unknow',
    manualMode: 'Manual',
    autoMode: 'Auto',
    originMode: 'Origin',
    // 注塑机
    imt1: 'Barrel Temp. 1',
    imt2: 'Barrel Temp. 2',
    imt3: 'Barrel Temp. 3',
    imt4: 'Barrel Temp. 4',
    imt5: 'Barrel Temp. 5',
    immc: 'Molding Cycle',
    imqty: 'Production Qty',
    imht1: 'Holding Time 1',
    imht2: 'Holding Time 2',
    imht3: 'Holding Time 3',
    imht4: 'Holding Time 4',
    imhp1: 'Holding Press. 1',
    imhp2: 'Holding Press. 2',
    imhp3: 'Holding Press. 3',
    imhp4: 'Holding Press. 4',
    imct: 'Cooling Time',
    imit: 'Injection Time',
    imis: 'Injection Speed',
    imip: 'Injection Press.',
    immn: 'Mold Count',
    immt: 'Measure Time',
    imrp: 'Residual Position',
    barrelTemperature: 'Barrel Temp.',
    holdingPressure: 'Holding Press.',
    injectionPressure: 'Injection Press.',
    // 温控箱
    tmcps: 'Injection Press.',
    tmcpt: 'Injection Temp.',
    //测温点状态
    tmcPSts0: 'Ready',
    tmcPSts1: 'Stop',
    tmcPSts2: 'SoftStart',
    tmcPSts3: 'AutoTuning',
    tmcPSts4: 'Auto',
    tmcPSts5: 'Stby',
    tmcPSts6: 'Manual',
    tmcPSts11: 'AL-H',
    tmcPSts12: 'AL-L',
    tmcPSts13: 'TC.Op',
    tmcPSts14: 'TC.Re',
    tmcPSts15: 'TC.St',
    tmcPSts16: 'HT.Op',
    tmcPSts17: 'HT.St',
    tmcPSts18: 'Tr.St',
    tmcPSts19: 'Fuse',
    // 保温干燥机
    hedsv: 'Set Temp.',
    hedpv: 'Actual Temp.',
    hedtup: 'Alarm High',
    hedtlow: 'Alarm Low',
    // 生产管理
    productionSubTitle: 'About Production Management',
    planID: 'Plan ID',
    productionNo: 'Production Code',
    customerCode: 'Customer Code',
    customerName: 'Customer Name',
    productionPlan: 'Production Plans',
    addPlan: 'Add Plan',
    productName: 'Production Name',
    planTotal: 'Plan Qty',
    productTotal: 'Finish Qty',
    takeTime: 'Plan Time',
    planStatus: 'Status',
    finishPlan: 'Finish',
    processPlan: 'Process',
    stopPlan: 'Stop',
    editProductionPlan: 'Edit Plan',
    startPlan: 'Start',
    timeRangeError: 'Please choose the right time range.',
    // 试模文档管理
    testFileSubTitle: 'About Test File Management',
    testFileID: 'File ID',
    testFileName: 'File Name',
    testFiles: 'Test Files',
    testFileInfo: 'Test File Info',
    testFilePhotos: 'Test File Photos',
    editTestFile: 'Edit Test File',
    personInCharge: 'Person In Charge',
    remark: 'Remark',
    photo: 'Photo',
    // 数据分析
    powerAnalysisMenu: 'Power',
    oeeAnalysisMenu: 'OEE',
    belongFactory: 'Factory',
    belongTag: 'Workshop',
    // 用电量分析
    deviceKindPower: 'Power consumption of device type',
    tagPowerList: 'Power consumption of all workshops',
    groupPowerList: 'Power consumption of all groups',
    powerCount: 'Power',
    percent: 'Percent',
    // 使用率分析
    allDeviceOEE: 'OEE of all devices',
    tagOEEList: 'OEE of all workshops',
    deviceKindOEEList: 'OEE of device type',
    groupOEEList: 'OEE of all groups',
    progress: 'Chart',
    deviceType: 'Device Type',
    // 报警管理
    alarmSubTitle: 'Show All Alarms',
    alarmList: 'Alarms',
    alarmContent: 'Alarm Content',
    alarmTime: 'Alarm Time',
    // 系统设置
    factoryManageMenu: 'Factories',
    tagManageMenu: 'Workshops',
    deviceManageMenu: 'Devices',
    userManageMenu: 'Users',
    // 工厂管理
    factoryName: 'Factory Name',
    addFactory: 'Add Factory',
    deviceCount: 'Device Count',
    tagCount: 'Workshop Count',
    groupCount: 'Group Count',
    editFactory: 'Edit Factory',
    delFactoryTip: 'We will delete all workshop, unit and equipment of the factory will be deleted. Please choose carefully.',
    // 车间管理
    addTag: 'Add Workshop',
    editTag: 'Edit Workshop',
    delTagTip: 'We will delete all units and equipment of the workshop. Please choose carefully.',
    // 设备管理
    belongGroup: 'Group',
    addDeviceMsg1: 'Please search the device information first.',
    addDeviceMsg2: 'The current device has been added, and cannot be added repeatedly.',
    addDeviceMsg3: 'The current device has been used by other customers.',
    editDevice: 'Edit Device',
    delDeviceTip: 'We will remove the current device from you, please choose carefully.',
    // 用户管理
    userName: 'User Name',
    userAccount: 'User Account',
    userPassword: 'User Pssword',
    userRank: 'User Rank',
    addUser: 'Add User',
    manageRank: 'Admin',
    normalRank: 'Noraml',
    changePassword: 'Pwd',
    editUser: 'Edit User',
    delUserTip: 'The user account can not be restored after being deleted. Please be careful.',

    /////////////////////////////////////////*TMMC:a*///////////////////////////////
    //登录界面
    a_noAccount: 'NoAccount',
    a_registerNow: 'SignUpNow',
    a_protocol1: 'By signing up, you agree and are willing to abide by YUDO',
    a_protocol2: 'User Agreement and Privacy Policy',
    a_hadAccount: 'ExistAccount',
    a_loginNow: 'DirectLogin',
    a_smsSended: 'SMS has been sent',
    a_captchaTitle: 'hold down the slider and drag to right',
    a_captchaSuccess: 'Verification passed',
    //二维码界面
    a_waitReview: 'Waiting for the administrator to scan the code review',
    a_qrcodeOver: 'QR code is invalid, click refresh',
    //我的设备
    a_cardShow: 'CardDisplay',
    a_listShow: 'ListDisplay',
    a_noShop: 'NoWorkshop',
    a_hasEmpty: 'Unfilled',
    //OEE
    a_allDayWorkStatus: '24-hour work status chart',
    a_workClass: 'Class',
    a_status: 'Status',
    a_statusCount: 'Count',
    a_usedTime: 'T_Consume',
    a_DataCount: 'DataStatistics',
    a_pdTarget: 'pdTarget',
    a_finishNm: 'Finish',
    a_rejectNm: 'RejectNum',
    a_noStart: 'HatStarted',
    //车间布局
    a_noLayoutImg: 'No layout',
    a_aboutLayout: 'Factory layout related',
    a_LayoutPic: 'Layout',
    //生产管理
    a_costAnalysis: 'CostAnalysis',
    a_staff: 'staff',
    a_deleteProductionPlan: 'Delete Production Plan',
    a_deleteProductionWaring: 'Deleting the production plan will delete all the information under the production plan and confirm the deletion?',
    //数据分析
    a_powerAnalysisMenu: 'Power',
    a_oeeAnalysisMenu: 'OEE',
    a_productAnalysisMenu: 'Yield',
    a_allPower: 'Total Ele',
    a_january: 'January',
    a_february: 'February',
    a_march: 'March',
    a_april: 'April',
    a_may: 'My',
    a_june: 'June',
    a_july: 'July',
    a_august: 'August',
    a_september: 'September',
    a_october: 'October',
    a_november: 'November',
    a_december: 'December',
    a_standend: 'Stdend',
    a_averageValue: 'AverageValue',
    a_allProductNm: 'Total Poduction',
    a_averageOee: 'Average Oee',
    //用户管理
    a_userManageAbout: 'User management related',
    a_registerTime: 'RegistrationTime',
    a_deleteUser: 'DelUser',
    a_deleteFail: 'Failed to Delete',
    a_sureDeleteUser: 'Make sure to delete the user',
    // 系统设置
    a_workTimeSet: 'Shift Setting',
    //车间管理
    a_deleteTag: 'Delete workshop',
    a_tagSort: 'ShopSort',
    a_deleteTagWaring: 'Delete the workshop will delete all the information under the workshop, confirm the deletion?',
    //排班设定
    a_addClass: 'Add Shift',
    a_saveClass: 'Save Shift',
    a_className: 'Shift Name',
    a_workingHours: 'WkHours',
    a_afterWorkingHours: 'AfterWkTime',
    a_editClass: 'Edit Shift',
    a_workingTime: 'Operating Hours',
    a_deleteClass: 'Delete Shift',
    a_sureDeleteClass: 'Make sure to delete the shift',
    //车间布局
    a_draw: 'Draw',
    a_toBeProcessed: 'To be processed',
    a_deviceAllNum: 'DeviceNm',
    a_pendingNum: 'WaitNm',
    a_description: 'Description',
    a_description1: 'Set the workshop width (width * height)',
    a_description2: 'Upload workshop bg image',
    a_description3: 'Drag the device in the pending area into the workshop box in the drawing area',
    a_description4: 'Double-click a rectangular block (single or multiple) to edit the position and size (X*Y, width * height)',
    a_description5: 'Double-click the rectangular block to delete the device',
    a_description6: 'Clear shop floor layout',
    a_description7: 'Design completed save shop layout',
    a_upload: 'Upload',
    a_reset: 'Reset',
    a_save: 'Save',
    a_saveSuccess: 'Successfully Saved',
    a_savefail: 'Save Failed',
    //设备管理
    a_unassignedWorkshop: 'Unallocated Workshop',
    a_NonAssignmentWorkshop: 'No Workshop',
    a_deviceSort: 'DeviceSort',
    a_sureDelDevice: 'Make sure to delete the device',

    /////////////////////////////////////////*TMCC:b*///////////////////////////////
    //设备种类
    b_MoldTemp: 'MoldTemp(KH54401A)',
    b_ThreeMachineDF: 'ThreeMachine(DF879500A)',
    b_CoolingWater: 'CoolingWater(SF306000A)',
    b_Cadryer: 'Cadryer(D-100)',
    b_ConveyorBelt: 'ConveyorBelt',
    b_AutoFeedingController: 'AutoFeedingController',
    b_Robot1100: 'Robot(TRC-1100)',
    b_InjectionJSU: 'Injection(JSU)',
    b_TMC: 'TMC',
    b_Dryer: 'Dryer(HC-100)',
    b_InjectionKLS: 'Injection(KLS)',
    b_Robot990: 'Robot(TRC-990)',
    b_ThreeMachineSF: 'ThreeMachine(SF879500A)',
    b_Mold: 'Mold(MOLD-01A)',
    b_AutoDetection: 'AutoDetection(F181219R-00-00A)',
    //首页
    b_groupSort: 'GroupSort',
    b_selectDevice: 'SelectDevice',
    b_operator: 'Operator',
    b_noZhuSuJi: 'The unit has no injection molding machine',
    //机组
    b_seeTMCDetail: "Show TMC Details",
    b_exitTMCDetail: "Exit TMC Details",
    b_noDevice: "There is no device",
    b_removeDevice: "Remove Device",
    b_timeRangeSearch: "Query by time period",
    b_realTime: "RealTime",
    b_hour: "h",
    b_day: "d",
    b_makeSure: "MakeSure",
    b_setShowProperies: "Set display properties",
    b_timeRangeEmpty: "Time range cannot be empty",
    b_endBeforeStart: "End time cannot be earlier than start time",
    b_only30Days: "Can only query data for nearly 30 days",
    b_rangeMore1Day: "The scope of the query cannot be greater than 1 day",
    b_mainDevice: 'Main Device',
    //报警
    b_serialTBOX: "TBOX-Serial",
    //机组管理
    b_groupM: "Groups",
    //设备管理
    b_unassignedGroup: 'Unallocated Group',
    b_NonAssignmentGroup: 'No Group',
};



// WEBPACK FOOTER //
// ./src/locale/en_us.js